import { create } from 'zustand';

const useInstallationsStore = create((set) => ({
  displayMode: 'Table',
  showInstallationModal: false,
  // When set, the modal opens in edit mode for this installation id.
  // null = create mode.
  editingInstallationId: null,
  selectedInstallation: null,
  isImportOpen: false,
  isEmissionsImportOpen: false,
  searchForm: {
    name: '',
    country: '',
  },
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },

  // Actions
  setDisplayMode: (mode) => set({ displayMode: mode }),
  setSelectedInstallation: (installation) => set({ selectedInstallation: installation }),
  setIsImportOpen: (isOpen) => set({ isImportOpen: isOpen }),
  setIsEmissionsImportOpen: (isOpen) => set({ isEmissionsImportOpen: isOpen }),
  setSearchForm: (form) => set({ searchForm: form }),
  setPagination: (pagination) =>
    set((state) => ({
      pagination: { ...state.pagination, ...pagination },
    })),
  resetSearchForm: () => set({ searchForm: { name: '', country: '' } }),

  // Convenience actions for the installation modal. Pass an id for edit
  // mode; omit (or pass null) for create mode.
  openInstallationModal: (id = null) =>
    set({ showInstallationModal: true, editingInstallationId: id }),
  closeInstallationModal: () => set({ showInstallationModal: false, editingInstallationId: null }),

  // Upload guide gating — hoisted so the page header can trigger the
  // installations upload flow from above the table. Mirrors the pattern
  // used in shipmentStore + suppliersStore. The wizard + guide modals
  // still mount inside InstallationsTable where their submit handlers
  // live. Emissions upload stays inside the table for now (different
  // modal stack, lower priority for header lift).
  showInstallationUploadGuide: false,
  setShowInstallationUploadGuide: (open) => set({ showInstallationUploadGuide: open }),

  triggerUploadFlow: () => {
    let hasSkipped = false;
    try {
      hasSkipped = window.localStorage.getItem('installations-upload-guide-skip') === 'always';
    } catch (_err) {
      // Ignore storage failures (private mode etc.).
    }
    if (hasSkipped) {
      set({ isImportOpen: true });
    } else {
      set({ showInstallationUploadGuide: true });
    }
  },

  // See suppliersStore.closeAllModals — same module-global lifetime problem,
  // same contract: navigation shuts every modal this store gates.
  closeAllModals: () =>
    set({
      showInstallationModal: false,
      editingInstallationId: null,
      isImportOpen: false,
      isEmissionsImportOpen: false,
      showInstallationUploadGuide: false,
    }),
}));

export default useInstallationsStore;
